import { useLocation } from "react-router-dom";

export const useSQQuery = () => {
  const query = new URLSearchParams(useLocation().search);
  return {
    query,
  };
};
